import React from 'react';
import Icon from '../../Icon/components/Icon';

const EmphasisIcon = (props) => {
  return (
    <Icon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <line x1="6" y1="4" x2="6" y2="14"/>
      <line x1="10" y1="4" x2="10" y2="14"/>
      <line x1="14" y1="4" x2="14" y2="14"/>
      <line x1="18" y1="4" x2="18" y2="14"/>
      <line x1="4" y1="18" x2="20" y2="18" strokeWidth="2.5"/>
    </Icon>
  );
};

export default EmphasisIcon;
